export const getPdfEN = {
    //Gumb za preuzimanje pdf-a
    "download_pdf_button": "Download"
}